export enum FiltrosIncidenciaEnum {
    PRIORIDAD = 'PRIORIDAD',
    NOMBRE = 'NOMBRE',
    ESTATUS = 'ESTATUS',
    RANGO_FECHA = 'RANGO FECHA',
    NUMERO_INCIDENCIA = 'NUMERO INCIDENCIA',
    EMPLEADO_ASIGNADO = 'EMPLEADO ASIGNADO',
    TIPO = 'TIPO'

}
